import { fetchInterceptor } from '../commons/Interceptor'
import { getTableauInfo, getToken } from '../environment'

export const queryViewPDF = async params => {
    const { BASE_URL, viewId } = getTableauInfo()

    const searchParams = new URLSearchParams(params)
    viewId.forEach(id => searchParams.append('viewId', id))

    return fetchInterceptor(`${BASE_URL}?${searchParams.toString()}`, {
        method: 'GET',
        headers: {
            Authorization: `${getToken()}`,
        },
    }).then(async response => {
        if (!response.ok) {
            throw new Error(
                `Falha ao gerar relatório. ${await response.text()}`
            )
        }

        return response
    })
}
